export const ONBOARDING_HOME_ADDRESS_EVENTS = {
  VIEW_ONBOARDING_HOME_ADDRESS: 'view_onboarding_home_address',
  SELECT_ONBOARDING_SEARCH_HOME_ADDRESS:
    'select_onboarding_search_home_address',
  SELECT_ONBOARDING_HOME_ADDRESS_CONTINUE:
    'select_onboarding_home_address_continue',
  SELECT_ONBOARDING_HOME_CONFIRM_ADDRESS_MODAL_EDIT:
    'select_onboarding_home_confirm_address_modal_edit',
  SELECT_ONBOARDING_HOME_CONFIRM_ADDRESS_MODAL_CONTINUE:
    'select_onboarding_home_confirm_address_modal_continue',
  VIEW_ONBOARDING_HOME_ADDRESS_POBOX_WARNING:
    'view_onboarding_home_address_pobox_warning',
} as const;
